import { toast } from "react-toastify";
import { timeToast } from "../../../Constant";
import DATA_TYPE from "../../../Constant/DataType";
import {
  APIUpdateSuccessMsg,
  getItemEditStatusSuccessMsg,
} from "../../../Constant/Message";

toast.configure();

const updateStatusRealokasi = async (axiosInstance, id, formData, isTarget) => {
  return await axiosInstance
    .put(
      isTarget ? `statusrealokasi/${id}` : `statusrealokasinontarget/${id}`,
      formData
    )
    .then((res) => {
      console.log(APIUpdateSuccessMsg);
      toast.success(getItemEditStatusSuccessMsg(DATA_TYPE.Realokasi), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
      return res;
    })
    .catch((error) => {
      console.error(error);
      toast.error(
        `PUT (Status Realokasi${!isTarget && " Non Target"}) ${error.message}`,
        {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: timeToast,
        }
      );
    });
};

export default updateStatusRealokasi;
